import { useMemo } from "react";
import { CollaboratorCustomFieldsService } from "@services/CollaboratorCustomFieldsService";
import { Application } from "@core/Application";
import CustomFieldsConfigScreen, { CustomFieldsConfigTexts } from "../CamposPersonalizados/CustomFieldsConfigScreen";
import { CustomFieldsConfigOptions } from "../CamposPersonalizados/CustomFieldsConfigScreenViewModel";

interface ConfiguracionColaboradoresScreenProps {
    orgID: string;
}

// Collaborator custom fields settings. The screen itself is shared with the
// qontact point custom fields (CustomFieldsConfigScreen); only the texts change.
const ConfiguracionColaboradoresScreen: React.FC<ConfiguracionColaboradoresScreenProps> = ({ orgID }) => {
    const customFieldsService = useMemo(
        () => new CollaboratorCustomFieldsService(Application.shared().coreDependencies.httpClient),
        [],
    );

    const options = useMemo<CustomFieldsConfigOptions>(() => ({
        typeExamples: {
            text: "Obra social".localized(),
            number: "Cantidad de hijos".localized(),
            date: "Fecha de ingreso".localized(),
            boolean: "Tiene transporte".localized(),
            list: "HORMIGON, ELECTRICIDAD".localized(),
        },
        loadErrorText: "No se pudieron cargar los campos de colaborador".localized(),
        editValueInUseErrorText: "No se pudo actualizar el campo. Si quitaste un valor, puede estar usado por un colaborador.".localized(),
        deleteInUseErrorText: "No se puede eliminar porque algún colaborador ya tiene información cargada en este campo. Desactivalo para que no vuelva a mostrarse.".localized(),
    }), []);

    const texts = useMemo<CustomFieldsConfigTexts>(() => ({
        title: "Campos colaboradores".localized(),
        subtitle: "Gestiona los campos adicionales disponibles en el perfil del colaborador.".localized(),
        loadingText: "Cargando campos de colaborador...".localized(),
        emptyText: "No hay campos creados".localized(),
        requiredDescription: "Si está activo, no se podrá guardar el colaborador sin completar este dato.".localized(),
        listValuesDescription: "Agregá los valores que después se podrán seleccionar en el colaborador.".localized(),
        namePlaceholder: "Obra social".localized(),
        listValuePlaceholder: "Ej. HORMIGON".localized(),
    }), []);

    return (
        <CustomFieldsConfigScreen
            orgID={orgID}
            customFieldsService={customFieldsService}
            options={options}
            texts={texts}
        />
    );
};

export default ConfiguracionColaboradoresScreen;
